import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://cricfight.in';

const ROUTE_META = {
  '/': {
    title: 'CricFight – Your Ultimate Cricket Destination',
    description: 'Create teams, challenge friends, and earn rewards. Live scores, statistics, and in-depth analysis of your favorite cricket matches. Join CricFight today!',
  },
  '/login': {
    title: 'Login – CricFight',
    description: 'Sign in to CricFight to manage your teams, challenges, and cricket stats.',
  },
  '/register': {
    title: 'Join CricFight – Sign Up',
    description: 'Create your CricFight account. Join the ultimate cricket challenge and start competing with friends.',
  },
  '/contact': {
    title: 'Contact Us – CricFight',
    description: 'Get in touch with the CricFight team. We\'d love to hear from you.',
  },
  '/feature-request': {
    title: 'Feature Request – CricFight',
    description: 'Suggest a feature or improvement for CricFight. Help us build the best cricket app.',
  },
  '/scorecard': {
    title: 'Scorecard – CricFight',
    description: 'Create and manage cricket scorecards. Start a match, track live scores, and share with friends.',
  },
  '/forgetpassword': {
    title: 'Forgot Password – CricFight',
    description: 'Reset your CricFight account password.',
  },
};

/**
 * Sets canonical URL, title, and meta description per route so Google
 * indexes the right URL and doesn't treat pages as duplicates.
 */
function SEO() {
  const { pathname } = useLocation();
  const path = pathname.endsWith('/') && pathname !== '/' ? pathname.slice(0, -1) : pathname;
  const canonicalUrl = `${BASE_URL}${path}`;
  const meta = ROUTE_META[path] || {
    title: 'CricFight – Your Ultimate Cricket Destination',
    description: 'Create teams, challenge friends, and earn rewards. Live scores and cricket analysis at CricFight.',
  };

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
    </Helmet>
  );
}

export default SEO;
